$(document).ready(function() {
    $('form.accept-quote button.accept-quote').last().attr('disabled', false);

    $('form.accept-quote').on('submit', function(e) {
        e.preventDefault();

        $form = $(this);

        $.post($(this).attr('action'), {'_token': $(this).find('[name="_token"]').val()}, function(data) {
            $button = $form.find('.accept-quote');
            $button.attr('disabled', true);
            $button.addClass('accepted');
            $button.html('<i class="fa fa-check"></i> Offerte Geaccepteerd');
        });
    });
});
